module.exports = __webpack_public_path__ + "static/Prayer-cc0cc1b1c70a7fae56c93b3661ca8573.png";